import { call, select } from 'redux-saga/effects'
import { selectAuthData, selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import { callApi } from '@/shared/tools/apiSagaHelper'
import * as Sentry from '@sentry/react'

export const billingModuleActions = {
  BILLING_MODULE_FETCH_PROMO_CODE_V2: 'BILLING_MODULE_FETCH_PROMO_CODE_V2',
  BILLING_IBAN_VALIDATION: 'BILLING_IBAN_VALIDATION',
}

export function* validateIban({ ibanValue, providerId, callback, callbackError }) {
  const { country } = yield select(selectAuthData)
  const { ibanValidationUrl: url } = yield select(selectExtraRoutesAuthData)
  const fullUrl = `${url}?country=${country}&iban=${encodeURIComponent(ibanValue)}&organizationId=${encodeURIComponent(providerId)}`

  try {
    const response = yield call(callApi, {
      endpoint: fullUrl,
      showErrorSnackbar: false,
      method: 'GET',
    })

    yield call(callback, response)
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('ibanValidationError'), { extra: { error } })
    }
    yield call(callbackError, error.message ?? error.toString())
  }
}

export function* fetchPromoCode({ params, callback }) {
  const { lang } = yield select(selectAuthData)
  const { getPromoCodeUrl: url } = yield select(selectExtraRoutesAuthData)
  const fullUrl = `${url}?lang=${lang}&${params}`
  try {
    const response = yield call(callApi, {
      endpoint: fullUrl,
      showErrorSnackbar: false,
      method: 'GET',
    })
    yield call(callback, response)
  } catch (error) {
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('fetchPromoCodeError'), { extra: { error } })
    }
  }
}
